import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const PullQuoteLoadable = loadable(() => import('./PullQuote'), {
  resolveComponent: components => components.PullQuote
});

export const PullQuote = WithLazyHydration(PullQuoteLoadable, {
  name: 'PullQuote'
});
